import LinksGridSection from './LinksGridSection';

export { type LinksGridSectionProps } from './LinksGridSection';
export default LinksGridSection;
